import { baseApi } from "./baseApi";
const MY_DAY_SUMMARY_BASE_URL = "/myDay-Summary";

export const myDaySummary = baseApi.injectEndpoints({
  tagTypes: ["MyDaySummary"],

  endpoints: (build) => ({
    getMyDaySummary: build.query({
      query: ({ metrics, ...rest }) => ({
        url: `${MY_DAY_SUMMARY_BASE_URL}/my-day`,
        params: {
          ...rest,
          metrics: Array.isArray(metrics) ? metrics.join(",") : metrics,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazyGetMyDaySummaryQuery } = myDaySummary;
